<template>
  <div class="works" id="works">
    <pcHeader
      @search="headerSearch"
      @onSearch="onSearch"
      @onCancel="onCancel"
      :login="login"
    ></pcHeader>
    <div
      class="share_box"
      @mouseenter="handleMouseEnterShare()"
      @mouseleave="handleMouseLeaveShare()"
    >
      <i class="iconfont icon-jr-icon-share"></i>
      <div class="QR_code_box" v-show="QRCodeShow">
        <van-image width="116" height="116" :src="QRCodeUrl">
          <template v-slot:loading>
            <van-loading type="spinner" size="20" />
          </template>

          <template v-slot:error>
            <van-loading type="spinner" size="20" />
          </template>
        </van-image>
      </div>
    </div>

    <div class="activity_details_box">
      <div class="activity_details_swiper">
        <!-- 头部banner轮播图 -->
        <van-swipe :autoplay="5000" indicator-color="#3562FF">
          <van-swipe-item v-for="(item, index) in activityData.pcDetailsImageList" :key="index">
            <img :src="item" alt="" title="" class="banner_img" />
          </van-swipe-item>
        </van-swipe>
        <div class="under_banner">
          <div class="under_banner_box">
            <div class="under_banner_box_left">
              <!-- 简介 作品 获奖 -->
              <div class="under_banner_bottom">
                <!-- 活动作品 -->
                <span @click="isWork = 2" :class="{ tabActive: isWork === 2 }">{{
                  $t('message.home.work_con')
                }}</span>
                <!-- 获奖作品 -->
                <span
                  v-if="activityData.isWorkShow || activityData.isPopularityAward"
                  @click="handleTabClick1"
                  :class="{ tabActive: isWork === 3 }"
                >
                  {{ this.$t('message.home.Award_works') }}</span
                >

                <!-- 机构榜单 -->
                <span
                  v-if="activityData.monthlyFocus || activityData.divisionMonthlyFocus"
                  @click="clickOrganization"
                  :class="{ tabActive: isWork === 4 }"
                >
                  {{ this.$t('message.home.List_of_Organizations') }}</span
                >

                <!-- 活动简介 -->
                <span @click="handleTabClick" :class="{ tabActive: isWork === 1 }">{{
                  $t('message.home.Introduction')
                }}</span>

                <div class="heat" @click="clickHeat" v-if="false">
                  <span class="text">按热度排序</span>
                  <span class="icon">
                    <div
                      class="top"
                      :style="{ 'background-color': heatClass == 2 ? '#000' : '#8f8f8f' }"
                    ></div>
                    <div
                      class="bottom"
                      :style="{ 'background-color': heatClass == 1 ? '#000' : '#8f8f8f' }"
                    ></div>
                  </span>
                </div>
              </div>

              <!-- 顶部投稿类型导航 -->
              <div class="nav_list_head" v-if="navTabList.length != 1">
                <span
                  @click="navHeaClick(item.type)"
                  v-for="(item, index) in navTabList"
                  :key="index"
                  :class="item.type === navTabIndex ? 'active' : ''"
                  >{{ getManuscriptLabel(item.type)
                  }}<!-- <span v-if="index !== navTabList.length - 1" class="nav_list_head_item">|</span> -->
                </span>
              </div>
            </div>

            <div class="under_banner_box_right">
              <!-- 主题 -->
              <div class="nav_list_works_left" ref="works" v-show="isWork != 4">
                <!-- ``` -->
                <van-button
                  class="nav_list_works_li"
                  round
                  size="normal"
                  @click="navListClick(index)"
                  v-for="(item, index) in activityData.activeThemeList"
                  :key="index"
                  :class="
                    navWorksIndex === index
                      ? 'nav_list_works_li_active'
                      : 'nav_list_works_li_disactive'
                  "
                >
                  {{ item }}
                </van-button>

                <div class="line"></div>
              </div>

              <!-- 进行中 -->
              <div class="under_banner_left">
                <div
                  v-show="item.icon != 'icon-jr-icon-works'"
                  v-for="(item, index) in activityData.contributeTypeList"
                  :key="index"
                >
                  <!-- <i class="iconfont" :class="item.icon"
                    ><span style="margin-left: 3px">{{ item.sumCount }}</span></i
                  > -->
                </div>
                <div>
                  <!-- {{ getActivityLabel(activityData.activeState) }} -->
                  <span v-if="activityData.activeState === 2"
                    >{{ $t('message.home.surplus')
                    }}<span class="under_banner_left_time">{{ activityData.timeRemaining }}</span
                    >{{ $t('message.home.days') }}</span
                  >
                </div>
              </div>

              <!-- 投稿 -->
              <div class="under_banner_middle">
                <van-popover
                  v-model="showItem"
                  :placement="placement"
                  :actions="actions"
                  @select="imageClick"
                  :get-container="getContainer"
                >
                  <template #reference>
                    <van-button
                      v-if="activityData.activeState == 2"
                      round
                      size="normal"
                      class="tougao"
                      @click="tabBarClick(1)"
                      >{{ $t('message.cpn.of_work') }}
                    </van-button>

                    <van-button
                      v-else-if="activityData.activeState === 3"
                      round
                      size="normal"
                      class="tougao tougao_state"
                      @click="tabBarClick(1)"
                      >{{ $t('message.home.event_ended') }}
                    </van-button>

                    <van-button
                      v-else-if="activityData.activeState === 1"
                      round
                      size="normal"
                      class="tougao tougao_state"
                      @click="tabBarClick(1)"
                      >{{ $t('message.home.event_start') }}
                    </van-button>
                  </template>
                </van-popover>

                <van-button v-if="false" @click="copy" round size="normal"
                  ><div>
                    <i class="iconfont icon-jr-icon-share1" style="margin-right: 8px"></i
                    >{{ $t('message.home.share') }}
                  </div></van-button
                >
              </div>
            </div>
          </div>
        </div>

        <div class="listData">
          <!-- 赛区榜单 -->
          <div v-show="isWork == 4 && activityData.divisionMonthlyFocus" class="division_table">
            <div class="organization_box">
              <div class="position_right">
                <img src="../../../../../static/image/赛区球.png" alt="" />
              </div>
              <div class="head_img_box">
                <div style="font-size: 0">
                  <img src="../../../../../static/image/赛区皇冠.png" alt="" />
                </div>
                赛区参与度排行榜
              </div>

              <div class="organization_content">
                <div class="organization_content_head">
                  <div class="organization_name">赛区名称</div>
                  <div class="number_works">作品</div>
                  <div v-if="navTabIndex != 2" class="number_img">图片</div>
                  <div v-else class="number_img">视频</div>
                </div>
                <div
                  class="organization_content_item"
                  v-for="(item, index) in divisionList"
                  :key="index"
                  @click="clickToContribute(item, index)"
                >
                  <div class="organization_name">
                    <div class="list_icon">
                      <img
                        src="../../../../../static/image/index(2).png"
                        alt=""
                        v-if="index == '0'"
                      />
                      <img
                        src="../../../../../static/image/index(1).png"
                        alt=""
                        v-else-if="index == '1'"
                      />
                      <img
                        src="../../../../../static/image/index.png"
                        alt=""
                        v-else-if="index == '2'"
                      />
                      <div class="icon_txt">{{ index + 1 }}</div>
                    </div>

                    <div class="organization_logo">
                      <img :src="item.logo" alt="" />
                    </div>

                    <div>{{ item.divisionName }}</div>
                  </div>
                  <!--  -->
                  <div class="number_works">
                    <div v-if="navTabIndex == 3">
                      {{ item.cumulativePicture }}
                    </div>

                    <div v-if="navTabIndex == 2">
                      {{ item.cumulativeVideo }}
                    </div>

                    <div v-if="navTabIndex == 4">{{ item.cumulativePaintings }}</div>

                    <div v-if="navTabIndex == 6">{{ item.cumulativeKechuang }}</div>
                  </div>
                  <div class="number_img">
                    <div v-if="navTabIndex == 3">
                      {{ item.cumulativePictureSum }}
                    </div>

                    <div v-if="navTabIndex == 2">
                      {{ item.cumulativeVideoSum }}
                    </div>

                    <div v-if="navTabIndex == 4">{{ item.cumulativePaintingsSum }}</div>

                    <div v-if="navTabIndex == 6">{{ item.cumulativeKechuangSum }}</div>

                    <div
                      style="
                        color: red;
                        background-color: #f9cdcd;
                        padding: 2px;
                        font-size: 10px;
                        border-radius: 4px;
                      "
                      v-if="index <= 2"
                    >
                      热
                    </div>

                    <div class="organization_content_item_state" v-if="navTabIndex == 3">
                      <div class="rise" v-if="item.lift > 0">
                        <div class="rise_icon"></div>
                        {{ item.lift }}
                      </div>

                      <div class="decline" v-else-if="item.lift < 0">
                        <div class="decline_icon"></div>
                        {{ item.lift | lift }}
                      </div>
                    </div>

                    <div class="organization_content_item_state" v-else-if="navTabIndex == 2">
                      <div class="rise" v-if="item.videoLift > 0">
                        <div class="rise_icon"></div>
                        {{ item.videoLift }}
                      </div>

                      <div class="decline" v-else-if="item.videoLift < 0">
                        <div class="decline_icon"></div>
                        {{ item.videoLift | lift }}
                      </div>
                    </div>

                    <div class="organization_content_item_state" v-else-if="navTabIndex == 4">
                      <div class="rise" v-if="item.paintingsLift > 0">
                        <div class="rise_icon"></div>
                        {{ item.paintingsLift }}
                      </div>

                      <div class="decline" v-else-if="item.paintingsLift < 0">
                        <div class="decline_icon"></div>
                        {{ item.paintingsLift | lift }}
                      </div>
                    </div>

                    <div class="organization_content_item_state" v-else-if="navTabIndex == 6">
                      <div class="rise" v-if="item.kechuangLift > 0">
                        <div class="rise_icon"></div>
                        {{ item.kechuangLift }}
                      </div>

                      <div class="decline" v-else-if="item.kechuangLift < 0">
                        <div class="decline_icon"></div>
                        {{ item.kechuangLift | lift }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 机构榜单 -->
          <div v-show="isWork == 4 && activityData.monthlyFocus" class="organization">
            <div class="organization_box">
              <div class="position_right">
                <img src="../../../../../static/image/赛区球-1.png" alt="" />
              </div>
              <div class="head_img_box">
                <!-- <img src="../../../../../static/image/2840.png" alt="" /> -->
                <div style="font-size: 0">
                  <img src="../../../../../static/image/机构皇冠.png" alt="" />
                </div>
                机构参与度排行榜
              </div>

              <div class="organization_content">
                <div class="organization_content_head">
                  <div class="organization_name">机构名称</div>
                  <div class="number_works">作品</div>
                  <div v-if="navTabIndex != 2" class="number_img">图片</div>
                  <div v-else class="number_img">视频</div>
                </div>
                <div
                  class="organization_content_item"
                  v-for="(item, index) in organizationList"
                  :key="index"
                  @click="clickToContributeTwo(item, index)"
                >
                  <div class="organization_name">
                    <div class="list_icon">
                      <img
                        src="../../../../../static/image/index(2).png"
                        alt=""
                        v-if="index == '0'"
                      />
                      <img
                        src="../../../../../static/image/index(1).png"
                        alt=""
                        v-else-if="index == '1'"
                      />
                      <img
                        src="../../../../../static/image/index.png"
                        alt=""
                        v-else-if="index == '2'"
                      />
                      <div class="icon_txt" v-else>{{ index + 1 }}</div>
                    </div>
                    <div class="organization_logo">
                      <img :src="item.logo" alt="" />
                    </div>

                    <div>{{ item.organizationName }}</div>
                  </div>
                  <div class="number_works">
                    <div v-if="navTabIndex == 3">
                      {{ item.photographySum }}
                    </div>

                    <div v-if="navTabIndex == 2">
                      {{ item.videoSum }}
                    </div>

                    <div v-if="navTabIndex == 4">{{ item.paintingsPicturesSum }}</div>

                    <div v-if="navTabIndex == 6">{{ item.kechuangPicturesSum }}</div>
                  </div>
                  <div class="number_img">
                    <div v-if="navTabIndex == 3">
                      {{ item.photographyPicturesSum }}
                    </div>

                    <div v-if="navTabIndex == 2">
                      {{ item.videoPicturesSum }}
                    </div>

                    <div v-if="navTabIndex == 4">{{ item.paintingsSum }}</div>

                    <div v-if="navTabIndex == 6">{{ item.kechuangSum }}</div>

                    <div
                      style="
                        color: red;
                        background-color: #f9cdcd;
                        padding: 2px;
                        font-size: 10px;
                        border-radius: 4px;
                      "
                      v-if="index <= 2"
                    >
                      热
                    </div>

                    <div class="organization_content_item_state" v-if="navTabIndex == 3">
                      <div class="rise" v-if="item.lift > 0">
                        <div class="rise_icon"></div>
                        {{ item.lift }}
                      </div>

                      <div class="decline" v-else-if="item.lift < 0">
                        <div class="decline_icon"></div>
                        {{ item.lift | lift }}
                      </div>
                    </div>

                    <div class="organization_content_item_state" v-else-if="navTabIndex == 2">
                      <div class="rise" v-if="item.videoLift > 0">
                        <div class="rise_icon"></div>
                        {{ item.videoLift }}
                      </div>

                      <div class="decline" v-else-if="item.videoLift < 0">
                        <div class="decline_icon"></div>
                        {{ item.videoLift | lift }}
                      </div>
                    </div>

                    <div class="organization_content_item_state" v-else-if="navTabIndex == 4">
                      <div class="rise" v-if="item.paintingsLift > 0">
                        <div class="rise_icon"></div>
                        {{ item.paintingsLift }}
                      </div>

                      <div class="decline" v-else-if="item.paintingsLift < 0">
                        <div class="decline_icon"></div>
                        {{ item.paintingsLift | lift }}
                      </div>
                    </div>

                    <div class="organization_content_item_state" v-else-if="navTabIndex == 6">
                      <div class="rise" v-if="item.kechuangLift > 0">
                        <div class="rise_icon"></div>
                        {{ item.kechuangLift }}
                      </div>

                      <div class="decline" v-else-if="item.kechuangLift < 0">
                        <div class="decline_icon"></div>
                        {{ item.kechuangLift | lift }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-show="isWork == 2">
          <div class="pc_index_main">
            <!-- 活动作品中，不需要赛区筛选，只要奖项名称筛选 -->
            <div class="sticky_second">
              <!-- <div class="saiqu" v-if="!SaiquShowAll">
                <div
                  class="saiqu_li"
                  @click="saiQuClick(index)"
                  v-for="(item, index) in SaiquList[0]"
                  :class="navSaiIndex === index ? 'active' : ''"
                  :key="index"
                  v-show="item == '全部赛区' ? (SaiquList[0].length >= 3 ? true : false) : true"
                >
                  {{ item }}
                </div>
                <div
                  v-if="SaiquList.length > 1"
                  @click="SaiquShowAll = !SaiquShowAll"
                  class="saiqu_li"
                >
                  {{ $t('message.cpn.more_division') }}
                </div>
              </div> -->
              <!-- <div class="saiqu" v-if="SaiquShowAll">
                <div v-for="(item, index1) in SaiquList" :key="index1">
                  <div
                    :class="navSaiIndex === index1 * 10 + index2 ? 'active' : ''"
                    :key="(index1 + 1) * 10 + index2"
                    class="saiqu_li"
                    @click="saiQuClick(index1 * 10 + index2, index1, index2)"
                    v-for="(saiqu, index2) in item"
                  >
                    {{ saiqu }}
                  </div>
                  <div
                    v-if="index1 === SaiquList.length - 1"
                    @click="SaiquShowAll = !SaiquShowAll"
                    class="saiqu_li"
                  >
                    {{ $t('message.cpn.away_all') }}
                  </div>
                </div>
              </div> -->
              <div class="saiqu">
                <div
                  class="saiqu_li"
                  v-for="(item, index) in SaiquList"
                  :key="index"
                  :class="{
                    active: index == navSaiIndex
                  }"
                  @click="clickItem(item, index)"
                  v-show="allShow ? index < SaiquList.length : index < 11"
                >
                  {{ item }}
                </div>
                <div v-if="SaiquList.length > 11" class="option">
                  <div class="saiqu_li" @click="clickAll" v-if="!allShow">
                    {{ $t('message.cpn.more_division') }}
                  </div>
                  <div class="saiqu_li" @click="clickStow" v-else>
                    {{ $t('message.cpn.away_all') }}
                  </div>
                </div>
              </div>

              <!-- 搜索 -->
              <!-- <div class="nav_list_works" :style="`height:${activeListHeight}px`">
                <div class="new_seach">
                  <van-search
                    shape="round"
                    :placeholder="$t('message.cpn.all_activity')"
                    @search="onSearch"
                    @pointercancel="onCancel"
                    v-model="queryInfo.activeSearch"
                  >
                  </van-search>
                </div>
              </div> -->
            </div>

            <div class="data_list">
              <van-list offset="300" v-model="loading" :finished="finished" @load="search()">
                <div
                  class="item data_list_li"
                  v-for="(item, index) in dataList"
                  :key="index"
                  @mouseenter="handleMouseEnter(item.id)"
                  @mouseleave="handleMouseLeave(item.id)"
                  :class="{
                    flex_grow: index >= dataList.length - 6
                  }"
                >
                  <div class="mask" v-show="item.isShow" @click="detailsClick(item)"></div>
                  <!-- 图片 -->
                  <div
                    class="img"
                    v-if="item.worksList && item.worksList.length"
                    @click="detailsClick(item)"
                  >
                    <!-- 用户上传图片数量 -->
                    <div class="abpos" v-if="item.worksList && item.worksList.length > 1">
                      <i class="icon-jr-icon-one iconfont"></i>
                      <span>{{ item.worksList.length }}</span>
                    </div>
                    <img
                      v-if="item.worksList && item.worksList.length"
                      v-lazy="item.worksList[0].workPath"
                      alt=""
                    />
                    <img v-else src="../../../../../static/image/moren.png" alt="" />
                  </div>
                  <!-- 视频 -->
                  <div
                    class="img"
                    v-else-if="item.workVideoList && item.workVideoList.length"
                    @click="detailsClick(item)"
                  >
                    <div class="abpos">
                      <i class="icon-jr-icon-one iconfont"></i>
                      <span>{{ item.workVideoList.length }}</span>
                    </div>
                    <img v-lazy="item.workVideoList[0]" />
                    <!-- <img v-else src="../../../../../static/image/moren.png" alt="" /> -->
                  </div>
                  <!-- 视频 -->
                  <div
                    class="img"
                    v-else-if="item.workTiffList && item.workTiffList.length"
                    @click="detailsClick(item)"
                  >
                    <div class="abpos">
                      <i class="icon-jr-icon-one iconfont"></i>
                      <span>{{ item.workTiffList.length }}</span>
                    </div>
                    <img v-lazy="item.workTiffList[0]" />
                    <!-- <img v-else src="../../../../../static/image/moren.png" alt="" /> -->
                  </div>
                  <div
                    class="img"
                    v-else
                    style="backgroundimage: url('../../../../../static/image/moren.png')"
                    @click="detailsClick(item)"
                  ></div>
                  <!-- 头像 -->
                  <div class="data_list_avater" v-show="item.isShow">
                    <img :src="item.headImgUrl" alt="头像" v-if="item.headImgUrl" />
                    <!-- https://imagecharacter.oss-cn-beijing.aliyuncs.com/image_data/index.png -->
                    <img src="../../../../../static/image/nan.png" alt="头像" v-else />
                    <span>{{ item.userNickname }}</span>
                  </div>
                  <div class="data_list_li_p" v-show="item.isShow">
                    <p @click="listWorskClick(item)">
                      <i
                        class="icon-jr-icon-good iconfont"
                        :style="{ color: item.isLike ? '#3562FF' : '#999999' }"
                      ></i>
                    </p>
                    <p v-if="!item.isVote" @click.stop="voteClick(item)">
                      <i
                        class="icon-jr-icon-vote iconfont"
                        :style="{ color: item.isVote ? '#EB2727' : '#999999' }"
                      ></i>
                    </p>
                    <p v-else @click="voteClickNo">
                      <i
                        class="icon-jr-icon-vote iconfont"
                        :style="{ color: item.isVote ? '#EB2727' : '#999999' }"
                      ></i>
                    </p>
                  </div>
                </div>
                <div class="data_list_img_show" v-if="showListImg">
                  <p>{{ $t('message.cpn.be_work') }}</p>
                </div>
              </van-list>
            </div>
          </div>

          <div class="data_list_img_show" style="text-align: center" v-if="dataList.length == 0">
            <img src="../../../../../static/image/no_works.png" alt="" />
            <p>{{ $t('message.home.coll') }}</p>
          </div>
        </div>
        <div>
          <item-activity v-show="isWork == 1" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入h5跳小程序
import wx from 'weixin-js-sdk'
const defaultQueryInfo = Object.freeze({
  activityId: '',
  pageNum: 1,
  keys: 1,
  orders: '',
  pageSize: 30,
  // 活动主题名称
  queryKey: '',
  worksType: '',
  activeSearch: '',
  competitionArea: '',
  language: sessionStorage.getItem('lang') ? sessionStorage.getItem('lang') : 'zhcn',
  conditionsOfVoting: ''
})
import pcHeader from '@/components/pcHeader'
// import activityDetails from './activityDetails.vue'
import { wexinShare } from '@/utils/wxshare'
import { wxShare } from '@/api/common'
import { getCookie } from '@/utils/cookie'
import { apiUser } from '@/api/user.js'
import {
  getDetailActivityWeb,
  getSaiqu,
  activeWinningListWeb,
  voteWorks,
  likeWorks,
  linksSave,
  systemQRCode,
  listMonthlyFocus,
  listDivisionMonthlyFocus
} from '@/api/activity'
import { Toast } from 'vant'
import ItemActivity from './comom/itemActivity.vue'
export default {
  name: 'Works',
  beforeRouteLeave(to, from, next) {
    // console.log(from.meta)
    if (to.path == '/activity/details' || to.path == '/activity/award') {
      next()
    }
    // else {
    //   sessionStorage.removeItem('isWorkShow')
    //   next()
    // }
    next()
  },
  data() {
    return {
      showListImg: false,
      loading: false,
      login: false,
      finished: false,
      queryInfo: { ...defaultQueryInfo },
      activityData: {
        contributeType: '',
        activeThemeList: []
      },
      // 展示所有赛区
      SaiquShowAll: false,
      // 投稿类型导航
      navTabList: [],
      statusList: [
        {
          label: this.$t('message.home.i_pro'),
          value: 2
        },
        {
          label: this.$t('message.home.t_start'),
          value: 1
        },
        {
          label: this.$t('message.home.ended'),
          value: 3
        }
      ],
      kindList: [
        {
          value: '1',
          label: this.$t('message.explain.g_txt')
        },
        {
          value: '2',
          label: this.$t('message.explain.voide')
        },
        {
          value: '3',
          label: this.$t('message.explain.photo')
        },
        {
          value: '4',
          label: this.$t('message.explain.pain')
        },
        {
          value: '5',
          label: this.$t('message.explain.animation')
        },
        {
          value: '6',
          label: this.$t('message.explain.sci_work')
        },
        {
          value: '7',
          label: this.$t('message.explain.sci_music')
        }
      ],
      // 选中的活动主题
      activeTheme: '',
      navWorksIndex: 0,
      navTabIndex: 0,
      divisionList: [],
      navSaiIndex: 0,
      showItem: false,
      imgTextShow: false, //图文
      videoShow: false, //视频
      photographyShow: false, //摄影
      paintingShow: false, //绘画
      comicShow: false, //动漫
      kechuangShow: false, //科创
      musicShow: false, //音乐
      // laseClick: true,
      isActive: false,
      SaiquList: [],
      dataList: [],
      worksType: 0,
      token: '',
      competitionArea: '',
      isWhether: 1,
      pageindex: 1,
      total: 0,
      newIndex: 0,
      activeListHeight: 0,
      active: 2,
      isWork: 2,
      isShowUser: false,
      userInfo: {},
      this_: this,
      heatClass: 0,
      listState: false,
      idS: [],
      dataS: [],
      scroll: 0,
      selectVal: '全部',
      allShow: false,
      placement: 'top',
      QRCodeShow: false,
      QRCodeUrl: '',
      getQrcCodeL: false,
      organizationList: [],
      queryOrganization: {
        activeId: '',
        worksType: '3', // 作品类型 1->图文投稿;2->视频投稿;3->摄影类;4->绘画类;5->动漫类;6->科创类;7->音乐
        howManyTheTop: '',
        language: '',
        orders: ''
      }
    }
  },
  filters: {
    lift(value) {
      let str = value + ''
      return str.split('-')[1]
    }
  },
  components: {
    ItemActivity,
    pcHeader
  },
  computed: {
    id() {
      return this.$route.query.id
    },
    organizationId() {
      return this.$route.query.organizationId * 1
    },
    divisionName() {
      return this.$route.query.divisionName
    },
    // isWorkShow() {
    //   return JSON.parse(sessionStorage.getItem('isWorkShow'))
    // },
    // 通过 actions 属性来定义菜单选项
    actions() {
      let arr = []
      this.navTabList.forEach((item) => {
        let str = this.getManuscriptLabel(item.type)
        let temp = { text: str + this.$t('message.cpn.bution'), type: item.type }
        arr.push(temp)
      })
      // console.log(arr)
      return arr
    }
  },

  created() {
    // if (sessionStorage.getItem('organizationId') != 0 && sessionStorage.getItem('organizationId')) {
    //   // this.openLink()
    //   console.log('web')
    // } else if (this.organizationId) {
    //   this.openLink()
    //   sessionStorage.setItem('organizationId', this.organizationId)
    // } else {
    //   sessionStorage.setItem('organizationId', 0)
    // }

    // if (sessionStorage.getItem('divisionName') != '' && sessionStorage.getItem('divisionName')) {
    //   console.log('web')
    // } else if (this.divisionName) {
    //   // console.log(11)
    //   sessionStorage.setItem('divisionName', this.divisionName)
    //   // id 如果外面带了赛区这个参数进来 把这个赛区名字和id存进去  然后再getActivityData方法里面判断，下次从首页进来活动页面是不是一样的id 果然是一样的id, 那么就在查询活动接口的divisionName返回第一次进这个活动所携带的divisionName参数
    //   sessionStorage.setItem('divisionNameId', this.id)
    // } else {
    //   sessionStorage.setItem('divisionName', '')
    // }

    if (this.organizationId) {
      this.openLink()
      sessionStorage.setItem('organizationId', this.organizationId)
    } else if (
      sessionStorage.getItem('organizationId') != 0 &&
      sessionStorage.getItem('organizationId')
    ) {
      // this.openLink()
      console.log('web')
    } else {
      sessionStorage.setItem('organizationId', 0)
    }

    if (this.divisionName) {
      // console.log(11)
      sessionStorage.setItem('divisionName', this.divisionName)
      // id 如果外面带了赛区这个参数进来 把这个赛区名字和id存进去  然后再getActivityData方法里面判断，下次从首页进来活动页面是不是一样的id 果然是一样的id, 那么就在查询活动接口的divisionName返回第一次进这个活动所携带的divisionName参数
      sessionStorage.setItem('divisionNameId', this.id)
    } else if (
      sessionStorage.getItem('divisionName') != '' &&
      sessionStorage.getItem('divisionName')
    ) {
      console.log('web')
    } else {
      sessionStorage.setItem('divisionName', '')
    }

    this.token = getCookie('token')
    if (this.token) {
      this.tokenShow = true
      this.getUser()
      this.isShowUser = true
    } else {
      this.tokenShow = false
      this.isShowUser = false
    }
    let list = this.$route.query.list
    if (list) {
      this.listState = true
      this.isWork = 4
      this.navTabIndex = list * 1
      this.queryOrganization.worksType = list * 1
    }

    this.getListShow()
    this.getActivityData()
    // this.getListMonthlyFocus()
    this.weixin()
  },

  updated() {
    this.$nextTick(() => {
      // 动态获取活动列表高度
      this.activeListHeight = this.$refs.works.offsetHeight
    })
  },
  // mounted() {
  //   this.$nextTick(() => {
  //     this.$refs.grid.masonry({
  //       // columnWidth: 200,
  //       itemSelector: '.grid-item',
  //       gutter: 10
  //     })
  //     // console.log(this)
  //   })
  // },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  activated() {
    //  如果是从首页跳转过来的 那么之前页面有缓存的话 滚动条还是会在原来的位置，现在重置一下，回到0
    // if (sessionStorage.getItem('from_app') == '从首页来的') {
    //   // console.log('11');
    //   let works = document.getElementById('works')
    //   let scrollHeight = works.parentNode
    //   scrollHeight.scrollTop = 0
    // } else {
    // 活动简介页面跳转到机构榜单 直接跳到活动作品页面

    this.isWork = 2
    if (this.$route.query.detailsList) {
      this.isWork = 4
    }
    this.$nextTick(() => {
      let works = document.getElementById('works')
      let scrollHeight = works.parentNode
      scrollHeight.scrollTop = this.scroll
    })
    // }
  },
  methods: {
    // 获取赛区榜单数据
    async getListMonthlyFocusTwo(worksType) {
      if (this.listState) {
        if (Object.prototype.toString.call(this.$route.query.list) == '[object Array]') {
          this.queryOrganization.worksType = this.$route.query.list[0]
        } else {
          this.queryOrganization.worksType = this.$route.query.list
        }
      } else if (worksType) {
        this.queryOrganization.worksType = worksType
      }
      this.queryOrganization.activeId = this.id
      const { data: res } = await listDivisionMonthlyFocus(this.queryOrganization)
      if (res.resultCode == 200) {
        this.divisionList = res.data
      }
    },

    // 获取榜单数据
    async getListMonthlyFocus(worksType) {
      if (this.listState) {
        if (Object.prototype.toString.call(this.$route.query.list) == '[object Array]') {
          this.queryOrganization.worksType = this.$route.query.list[0]
        } else {
          this.queryOrganization.worksType = this.$route.query.list
        }
      } else if (worksType) {
        this.queryOrganization.worksType = worksType
      }
      this.queryOrganization.activeId = this.id
      const { data: res } = await listMonthlyFocus(this.queryOrganization)
      if (res.resultCode == 200) {
        this.organizationList = res.data
      }
    },
    // 二维码,,鼠标移入事件
    async handleMouseEnterShare() {
      // console.log('移入了')
      this.QRCodeShow = true
      if (this.QRCodeUrl == '' && !this.getQrcCodeL) {
        // console.log('调用接口')
        // this.QRCodeUrl
        this.getQrcCodeL = true
        let query = {
          activeId: this.id, // 活动id
          orgName: sessionStorage.getItem('schema')
        }
        const { data: res } = await systemQRCode(query)
        // 转base64  显示二维码图片路径
        const src =
          'data:image/png;base64,' +
          btoa(new Uint8Array(res).reduce((data, byte) => data + String.fromCharCode(byte), ''))
        // console.log(src)
        this.QRCodeUrl = src
      } else {
        return
      }
    },
    // 二维码,,鼠标移出事件
    handleMouseLeaveShare() {
      // console.log('移出了')
      this.QRCodeShow = false
    },
    getContainer() {
      return document.querySelector('.under_banner_middle')
    },
    clickItem(item, index) {
      this.pageindex = 1
      this.dataList = []
      this.navSaiIndex = index
      // console.log(this.navSaiIndex, index)

      if (index == 0) {
        this.queryInfo.competitionArea = ''
      } else {
        this.queryInfo.competitionArea = item
      }
      this.finished = false
      this.search()
    },
    // 点击展示全部赛区
    clickAll() {
      this.allShow = true
    },
    // 收起赛区
    clickStow() {
      this.allShow = false
    },
    headerSearch() {
      // this.SaiquList = [[this.$t('message.home.allreg')]]
      // if (
      //   sessionStorage.getItem('organizationId') != 0 &&
      //   sessionStorage.getItem('organizationId')
      // ) {
      //   // this.openLink()
      //   console.log('web')
      // } else if (this.organizationId) {
      //   this.openLink()
      //   sessionStorage.setItem('organizationId', this.organizationId)
      // } else {
      //   sessionStorage.setItem('organizationId', 0)
      // }

      // if (sessionStorage.getItem('divisionName') != '' && sessionStorage.getItem('divisionName')) {
      //   console.log('web')
      // } else if (this.divisionName) {
      //   sessionStorage.setItem('divisionName', this.divisionName)
      // } else {
      //   sessionStorage.setItem('divisionName', '')
      // }

      if (this.organizationId) {
        this.openLink()
        sessionStorage.setItem('organizationId', this.organizationId)
      } else if (
        sessionStorage.getItem('organizationId') != 0 &&
        sessionStorage.getItem('organizationId')
      ) {
        // this.openLink()
        console.log('web')
      } else {
        sessionStorage.setItem('organizationId', 0)
      }

      if (this.divisionName) {
        // console.log(11)
        sessionStorage.setItem('divisionName', this.divisionName)
        // id 如果外面带了赛区这个参数进来 把这个赛区名字和id存进去  然后再getActivityData方法里面判断，下次从首页进来活动页面是不是一样的id 果然是一样的id, 那么就在查询活动接口的divisionName返回第一次进这个活动所携带的divisionName参数
        sessionStorage.setItem('divisionNameId', this.id)
      } else if (
        sessionStorage.getItem('divisionName') != '' &&
        sessionStorage.getItem('divisionName')
      ) {
        console.log('web')
      } else {
        sessionStorage.setItem('divisionName', '')
      }
      this.token = getCookie('token')
      if (this.token) {
        this.tokenShow = true
        this.getUser()
        this.isShowUser = true
      } else {
        this.tokenShow = false
        this.isShowUser = false
      }
      this.kindList = [
        {
          value: '1',
          label: this.$t('message.explain.g_txt')
        },
        {
          value: '2',
          label: this.$t('message.explain.voide')
        },
        {
          value: '3',
          label: this.$t('message.explain.photo')
        },
        {
          value: '4',
          label: this.$t('message.explain.pain')
        },
        {
          value: '5',
          label: this.$t('message.explain.animation')
        },
        {
          value: '6',
          label: this.$t('message.explain.sci_music')
        }
      ]
      this.getActivityData()
      this.getListShow()
      this.getListMonthlyFocus()
      this.getListMonthlyFocusDivision()
      this.search()
      this.weixin()
    },
    handleScroll() {
      let works = document.getElementById('works')
      if (works) {
        let scrollHeight = works.parentNode
        this.$nextTick(() => {
          this.scroll = scrollHeight.scrollTop
        })
      }
      // console.log(works.scrollTop);
    },
    // 点击热度排序
    clickHeat() {
      this.heatClass += 1
      if (this.heatClass == 3) {
        this.heatClass = 0
      }
      if (this.heatClass == 0) {
        this.queryInfo.keys = 1
        this.queryInfo.orders = ''
        this.search()
      } else {
        this.queryInfo.keys = ''
        this.queryInfo.orders = this.heatClass
        this.search()
      }

      // console.log(this.heatClass)
    },
    // 通过链接进来调起接口
    async openLink() {
      const { data } = await linksSave({
        organizationId: this.organizationId,
        activeId: this.id * 1
      })
      if (data.resultCode == 200) {
        console.log(data, '------')
      }
    },
    async weixin() {
      var urls = window.location.href
      const { data: res } = await wxShare({ url: urls })
      if (res.code === 102400) {
        var obj = {
          appId: res.appId,
          nonceStr: res.nonceStr,
          signature: res.signature,
          timestamp: res.timestamp,
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
        }
        let shareData = {
          title: this.$t('message.home.yuanjing'), // 分享标题
          desc: this.$t('message.home.p_yuanjing'),
          link: urls,
          // link: window.location.href,
          imgUrl:
            'https://imagecharacter.oss-cn-beijing.aliyuncs.com/image_data/%E5%85%83%E6%99%AF%E4%BA%91logo-01.png' // 分享图标
        }
        wexinShare(obj, shareData)
      }
    },
    voteClickNo() {
      Toast.fail(this.$t('message.cpn.voted'))
    },
    async voteListClick(row) {
      console.log(row, 'chufa111')
      const now = 86400000
      const bol =
        Date.parse(new Date()) - Date.parse(new Date(this.activityData.activeEndTime)) > now * 7
      if (bol) {
        return Toast.fail(this.$t('message.home.voting_tips'))
      }
      const worksPraise = {
        worksId: row.id,
        conditionsOfVoting: this.activityData.conditionsOfVoting
      }
      const { data: res } = await voteWorks(worksPraise)
      if (res.resultCode === 200) {
        this.pageindex = 1
        this.dataList = []
        this.search()
        Toast.success(this.$t('message.home.succ_vote'))
        // this.getActivityData()
        // this.getListShow()
      } else {
        Toast.fail(this.$t('message.home.network'))
      }
    },
    // web端
    voteClick(row) {
      console.log(row, 'ro11111111w')

      // 广告入口已开启
      if (row.exportAdvertising) {
        // 不在微信环境内，可以给出提示或者跳转到其他页面
        alert('请在微信环境内打开H5页面后再尝试操作！')
      } else {
        if (this.tokenShow) {
          this.voteListClick(row)
        } else {
          console.log(this.$t('message.home.log_first'), '123456')
          Toast.fail(this.$t('message.home.log_first'))
          // setTimeout(() => {
          //   this.$router.push({
          //     path: '/login/info'
          //   })
          // }, 1000)
          this.login = !this.login
        }
      }
    },
    searchClick() {
      this.$router.push({
        name: 'searchList',
        query: {
          activityId: this.queryInfo.activityId,
          competitionArea: this.queryInfo.competitionArea,
          worksType: this.queryInfo.worksType,
          queryKey: this.queryInfo.queryKey
        }
      })
    },
    detailsClick(row) {
      // console.log(row.award)
      this.dataList.forEach((item, index) => {
        this.idS.push(item.id)
      })
      let idx = null
      this.idS.forEach((item, id) => {
        if (row.id == item) {
          return (idx = id)
        }
      })
      if (idx != null) {
        this.idS = this.idS.slice(idx + 1)
      }
      // console.log(this.idS);
      // console.log(this.queryInfo)
      this.$route.meta.keepAlive = true
      // let routeUrl = this.$router.resolve({
      let routeUrl = this.$router.resolve({
        name: 'worksDetails',
        query: {
          id: row.id,
          queryInfo: JSON.stringify(this.queryInfo),
          pageNum: this.queryInfo.pageNum,
          idS: JSON.stringify(this.idS),
          pages: this.dataS.pages,
          conditionsOfVoting: this.activityData.conditionsOfVoting,
          activeEndTime: this.activityData.activeEndTime
        }
      })
      // 跳转新页面
      window.open(routeUrl.href, '_blank')
    },
    navHeaClick(index) {
      // loading为true 代表还在请求中
      if (this.loading) {
        return
      }
      this.pageindex = 1
      this.dataList = []
      this.navTabIndex = index
      this.queryOrganization.worksType = this.navTabIndex
      this.finished = false
      this.getListMonthlyFocus()
      this.getListMonthlyFocusTwo()
      this.search()
    },

    navListClick(index) {
      if (this.loading) {
        return
      }
      this.pageindex = 1
      this.dataList = []
      this.navWorksIndex = index
      this.finished = false
      // 拿到活动名称
      this.activeTheme = this.navWorksIndex !== -1 ? this.activityData.activeThemeList[index] : ''
      if (this.activeTheme == '全部') {
        this.activeTheme = ''
      }
      this.search()
    },
    saiQuClick(index, index1 = 0, index2 = index) {
      this.pageindex = 1
      this.dataList = []
      this.navSaiIndex = index
      if (index === 0) {
        this.queryInfo.competitionArea = ''
      } else {
        this.queryInfo.competitionArea = this.SaiquList[index1][index2]
      }
      // console.log(this.SaiquList)
      this.finished = false
      this.search()
    },
    arrDuplicateRemoval(arr, id) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr[id]) && res.set(arr[id], 1))
    },
    async search() {
      // console.log(this.navTabIndex)
      if (this.navTabIndex == 0) {
        // alert(this.navTabIndex)
        return (this.loading = false)
      }
      this.loading = true
      this.queryInfo.activityId = this.id
      this.queryInfo.worksType = this.navTabIndex
      this.queryInfo.pageNum = this.pageindex
      this.queryInfo.queryKey = this.activeTheme
      this.queryInfo.conditionsOfVoting = this.activityData.conditionsOfVoting
      // console.log(11);
      this.queryInfo.language = sessionStorage.getItem('lang')
        ? sessionStorage.getItem('lang')
        : 'zhcn'
      const { data: res } = await activeWinningListWeb(this.queryInfo)
      if (res.resultCode === 200) {
        this.dataList = [...this.dataList, ...res.data.list]
        this.dataS = res.data
        this.total = res.data.total
        this.dataList = this.arrDuplicateRemoval(this.dataList, 'id')
        this.loading = false
        if (res.data.hasNextPage) {
          this.pageindex++
        } else {
          this.finished = true
        }
      } else {
        this.finished = true
        this.loading = false
      }
    },
    async getListShow() {
      const { data: res } = await getSaiqu({
        id: this.id,
        language:
          sessionStorage.getItem('lang') == undefined ? 'zhcn' : sessionStorage.getItem('lang')
      })
      if (res.resultCode === 200) {
        if (!res.data) {
          return
        }
        this.SaiquList = res.data
        this.SaiquList.unshift(this.$t('message.home.allreg'))
        let i = this.SaiquList.indexOf(this.$route.query.divisionName)
        // console.log(i)
        if (i != -1) {
          this.navSaiIndex = i
          this.queryInfo.competitionArea = this.SaiquList[i]
        } else {
          this.queryInfo.competitionArea = ''
          this.navSaiIndex = 0
        }
        if (i > 11) {
          this.allShow = true
        }
      }
    },
    async getActivityData() {
      // console.log('123')
      // const url = 'https://imagecharacter.oss-cn-beijing.aliyuncs.com/'
      let divisionName = ''

      if (sessionStorage.getItem('divisionNameId') == this.id) {
        divisionName =
          sessionStorage.getItem('divisionName') == '' ? '' : sessionStorage.getItem('divisionName')
      } else {
        divisionName = ''
      }
      // console.log(divisionName)
      const { data: res } = await getDetailActivityWeb({
        id: this.id,
        language:
          sessionStorage.getItem('lang') == undefined ? 'zhcn' : sessionStorage.getItem('lang'),
        divisionName: divisionName
      })
      if (res.resultCode === 200) {
        this.isWhether = res.data.isWhether
        this.activityData = res.data
        if (this.activityData.pcDetailsImageList == null) {
          this.placement = 'bottom'
        }
        if (res.data.activeThemeList !== null && res.data.activeThemeList) {
          this.activityData.activeThemeList.unshift(this.$t('message.home.i_all'))
        }
        console.log(res.data.activeThemeList, 'res.data.activeThemeList')

        let str = this.activityData.contributeType
        if (this.activityData.contributeTypeList) {
          this.navTabList = this.activityData.contributeTypeList
          this.navTabIndex = this.navTabList[0].type
        }

        let list = this.$route.query.list
        if (list) {
          this.listState = true
          this.isWork = 4
          this.navTabIndex = list
          this.queryOrganization.worksType = list
          // this.queryOrganization.worksType = list
          // this.navTabIndex = list * 1
          // console.log(this.navTabIndex)
        }
        this.getListMonthlyFocusTwo(res.data.contributeType[0])
        this.getListMonthlyFocus(res.data.contributeType[0])
        this.search()
      }
    },
    clickToContribute(item, index) {
      this.navSaiIndex = this.SaiquList.indexOf(item.divisionName)
      this.queryInfo.competitionArea = item.divisionName
      this.navListClick(1)
      this.isWork = 2
      // let token = getCookie('token')
      // if (!token) {
      //   Toast.fail(this.$t('message.home.first_log'))
      //   this.showItem = false
      //   setTimeout(() => {
      //     this.$router.push({
      //       path: '/login/info'
      //     })
      //   }, 1000)

      //   return
      // }

      // if (this.navTabIndex == 3) {
      //   if (this.activityData.notSignUp) {
      //     this.$router.push({
      //       name: 'SignUp',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName
      //       }
      //     })
      //   } else {
      //     this.$router.push({
      //       name: 'UploadWorks',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName
      //       }
      //     })
      //   }
      // } else if (this.navTabIndex == 2) {
      //   if (this.activityData.notVideoSignUp) {
      //     this.$router.push({
      //       name: 'SignUp',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName
      //       }
      //     })
      //   } else {
      //     this.$router.push({
      //       name: 'UploadWorks',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName
      //       }
      //     })
      //   }
      // } else if (this.navTabIndex == 4) {
      //   if (this.activityData.notPaintingSignUp) {
      //     this.$router.push({
      //       name: 'SignUp',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName
      //       }
      //     })
      //   } else {
      //     this.$router.push({
      //       name: 'UploadWorks',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName
      //       }
      //     })
      //   }
      // } else if (this.navTabIndex == 6) {
      //   if (this.activityData.notKeChangeSignUp) {
      //     this.$router.push({
      //       name: 'SignUp',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName
      //       }
      //     })
      //   } else {
      //     this.$router.push({
      //       name: 'UploadWorks',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName
      //       }
      //     })
      //   }
      // }
    },
    clickToContributeTwo(item) {
      this.navSaiIndex = this.SaiquList.indexOf(item.divisionName)
      this.queryInfo.competitionArea = item.divisionName
      this.navListClick(1)
      this.isWork = 2
      // let token = getCookie('token')
      // if (!token) {
      //   Toast.fail(this.$t('message.home.first_log'))
      //   this.showItem = false
      //   setTimeout(() => {
      //     this.$router.push({
      //       path: '/login/info'
      //     })
      //   }, 1000)
      //   return
      // }
      // // console.log(item)
      // // console.log(item.organizationId);
      // if (this.navTabIndex == 3) {
      //   if (this.activityData.notSignUp) {
      //     this.$router.push({
      //       name: 'SignUp',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName,
      //         organizationId: item.organizationId
      //       }
      //     })
      //   } else {
      //     this.$router.push({
      //       name: 'UploadWorks',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName,
      //         organizationId: item.organizationId
      //       }
      //     })
      //   }
      // } else if (this.navTabIndex == 2) {
      //   if (this.activityData.notVideoSignUp) {
      //     this.$router.push({
      //       name: 'SignUp',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName,
      //         organizationId: item.organizationId
      //       }
      //     })
      //   } else {
      //     this.$router.push({
      //       name: 'UploadWorks',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName,
      //         organizationId: item.organizationId
      //       }
      //     })
      //   }
      // } else if (this.navTabIndex == 4) {
      //   if (this.activityData.notPaintingSignUp) {
      //     this.$router.push({
      //       name: 'SignUp',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName,
      //         organizationId: item.organizationId
      //       }
      //     })
      //   } else {
      //     this.$router.push({
      //       name: 'UploadWorks',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName,
      //         organizationId: item.organizationId
      //       }
      //     })
      //   }
      // } else if (this.navTabIndex == 6) {
      //   if (this.activityData.notKeChangeSignUp) {
      //     this.$router.push({
      //       name: 'SignUp',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName,
      //         organizationId: item.organizationId
      //       }
      //     })
      //   } else {
      //     this.$router.push({
      //       name: 'UploadWorks',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName,
      //         organizationId: item.organizationId
      //       }
      //     })
      //   }
      // }
    },
    imageClick(action) {
      // 3==>"摄影类投稿"   2==>"视频类投稿"   4==>"绘画类投稿"  6==> "科创类投稿"
      // console.log(action, '====')
      if (action.type == 3) {
        if (this.activityData.notSignUp) {
          this.$router.push({
            name: 'SignUp',
            query: { id: this.id, index: action.type, isWhether: this.isWhether }
          })
        } else {
          this.$router.push({
            name: 'UploadWorks',
            query: { id: this.id, index: action.type, isWhether: this.isWhether }
          })
        }
      } else if (action.type == 2) {
        if (this.activityData.notVideoSignUp) {
          this.$router.push({
            name: 'SignUp',
            query: { id: this.id, index: action.type, isWhether: this.isWhether }
          })
        } else {
          this.$router.push({
            name: 'UploadWorks',
            query: { id: this.id, index: action.type, isWhether: this.isWhether }
          })
        }
      } else if (action.type == 4) {
        if (this.activityData.notPaintingSignUp) {
          this.$router.push({
            name: 'SignUp',
            query: { id: this.id, index: action.type, isWhether: this.isWhether }
          })
        } else {
          this.$router.push({
            name: 'UploadWorks',
            query: { id: this.id, index: action.type, isWhether: this.isWhether }
          })
        }
      } else if (action.type == 6) {
        if (this.activityData.notKeChangeSignUp) {
          this.$router.push({
            name: 'SignUp',
            query: { id: this.id, index: action.type, isWhether: this.isWhether }
          })
        } else {
          this.$router.push({
            name: 'UploadWorks',
            query: { id: this.id, index: action.type, isWhether: this.isWhether }
          })
        }
      }
      // console.log(this.activityData.notSignUp, 'notSignUp,摄影类型')
      // console.log(this.activityData.notVideoSignUp, 'notVideoSignUp,视频类型')
      // console.log(this.activityData.notPaintingSignUp, 'notPaintingSignUp,绘画类型')
      // console.log(this.activityData.notKeChangeSignUp, 'notKeChangeSignUp,科创类型')
      // if (this.activityData.notSignUp) {
      //   this.$router.push({
      //     name: 'SignUp',
      //     query: { id: this.id, index: action.type, isWhether: this.isWhether }
      //   })
      // } else {
      //   this.$router.push({
      //     name: 'UploadWorks',
      //     query: { id: this.id, index: action.type, isWhether: this.isWhether }
      //   })
      // }
    },
    // 点击上传作品
    tabBarClick(val) {
      if (val == 1) {
        let token = getCookie('token')
        if (token) {
          if (this.navTabList.length === 1 && this.activityData.activeState === 2) {
            this.showItem = false
            // 当只有一种投稿类型时，判断登陆状态后直接进入投稿页面
            if (this.activityData.notSignUp) {
              if (this.activityData.activeState === 3) {
                this.showItem = false
                Toast.fail(this.$t('message.home.event_ended'))
              } else {
                this.$router.push({
                  name: 'SignUp',
                  query: {
                    id: this.id,
                    index: this.activityData.contributeTypeList[0].type * 1,
                    isWhether: this.isWhether
                  }
                })
              }
            } else {
              if (this.activityData.activeState === 3) {
                this.showItem = false
                Toast.fail(this.$t('message.home.event_ended'))
              } else {
                this.$router.push({
                  name: 'UploadWorks',
                  query: {
                    id: this.id,
                    index: this.activityData.contributeTypeList[0].type * 1,
                    isWhether: this.isWhether
                  }
                })
              }
            }
          } else {
            // 有多种投稿类型时，且活动进行中
            if (this.activityData.activeState === 2) {
              // if (this.laseClick) {
              //   this.showItem = true
              //   this.laseClick = false
              // } else {
              //   this.showItem = false
              //   this.laseClick = true
              // }
              this.showItem = !this.showItem
            } else if (this.activityData.activeState === 1) {
              this.showItem = false
              Toast.fail(this.$t('message.home.event_start'))
            } else if (this.activityData.activeState === 3) {
              this.showItem = false
              Toast.fail(this.$t('message.home.event_ended'))
            }
          }
        } else {
          Toast.fail(this.$t('message.home.first_log'))
          this.showItem = false
          // setTimeout(() => {
          //   this.$router.push({
          //     path: '/login/info'
          //   })
          // }, 1000)
          this.login = !this.login
        }
      }
    },
    onClickLeft() {
      this.$router.push({
        name: 'Activity'
      })
    },
    getActivityLabel(status) {
      let temp = ''
      this.statusList.forEach((item) => {
        if (item.value === status) {
          temp = item.label
        }
      })
      return temp
    },
    // 根据作品类型列表码值得到中文名
    getManuscriptLabel(type) {
      let temp = ''
      this.kindList.forEach((item) => {
        if (item.value === type) temp = item.label
      })
      return temp
    },
    // 每一项鼠标移入处理事件
    handleMouseEnter(id) {
      this.dataList.forEach((item) => {
        if (item.id === id) item.isShow = true
      })
    },
    handleMouseLeave(id) {
      this.dataList.forEach((item) => {
        if (item.id === id) item.isShow = false
      })
    },
    handleTabClick() {
      // this.isWork = 1
      this.$router.push({
        path: '/activity/details',
        query: {
          id: this.id
        }
      })
    },
    // 获奖作品
    handleTabClick1() {
      this.$router.push({
        path: '/activity/award',
        query: {
          id: this.id
        }
      })
    },
    clickOrganization() {
      this.isWork = 4
    },
    async getUser() {
      const { data: res } = await apiUser()
      if (res.resultCode === 200) {
        this.userInfo = res.data
      }
    },
    // 登录后才能点赞
    listWorskClick(item) {
      if (this.token) {
        this.listWorsk(item)
      } else {
        Toast.fail(this.$t('message.cpn.please_log'))
        this.login = !this.login
        // setTimeout(() => {
        //   this.$router.push({
        //     path: '/login/info'
        //   })
        // }, 1000)
      }
    },
    // 点赞
    async listWorsk(item) {
      const worksPraise = {
        worksId: item.id
      }
      const { data: res } = await likeWorks(worksPraise)
      if (res.resultCode === 200) {
        if (item.isLike) {
          item.isLike = false
          Toast.success(this.$t('message.home.unlike'))
        } else {
          item.isLike = true
          Toast.success(this.$t('message.home.liked_suc'))
        }
        this.search()
      } else {
        Toast.fail(this.$t('message.home.network'))
      }
    },
    // 搜索
    onSearch(val) {
      // console.log(val)
      this.queryInfo.activeSearch = val
      this.pageindex = 1
      this.dataList = []
      this.search()
    },
    //取消
    onCancel(val) {
      // console.log(val)
      this.queryInfo.activeSearch = val
      this.pageindex = 1
      this.dataList = []
      this.queryInfo.activeSearch = ''
      this.search()
    },
    copy() {
      this.$copyText(window.location.href).then(
        (e) => {
          Toast.success(this.$t('message.user.copy_suc'))
        },
        (e) => {
          Toast.success(this.$t('message.user.copy_failed'))
        }
      )
    }
  }
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: YouSheBiaoTiHei;
  src: url('../../../../../static/font/YouSheBiaoTiHei-2.ttf');
}
.tabActive {
  font-size: 17px;
  font-weight: 600;

  border-bottom: 2px solid #3562ff;
  color: #3562ff;
}
/deep/ .van-list__finished-text {
  width: 100%;
  text-align: center;
}
.works {
  width: 100%;
  .share_box {
    position: fixed;
    top: 50%;
    right: 7%;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-radius: 50%;
    z-index: 100;
    box-shadow: 0px 1px 8px 1px rgba(0, 0, 0, 0.1);

    .QR_code_box {
      position: absolute;
      top: 40px;
      left: 50%;
      width: 116px;
      height: 116px;
      transform: translateX(-50%);
      box-shadow: 0px 1px 8px 1px rgba(0, 0, 0, 0.1);
    }
  }

  .activity_details_box {
    // width: 100%;
    // text-align: center;

    .activity_details_swiper {
      // display: inline-block;
      // max-width: 1920px;
      max-width: 100%;

      .banner_img {
        display: block;
        width: 100%;
        // height: 836px;
        max-height: 836px;
        // object-fit: cover;
        // object-fit: contain;
      }
      .under_banner {
        height: 67px;
        // line-height: 50px;
        width: 100%;
        // position: relative;
        background-color: rgb(247, 248, 250);
        // text-align: center;
        display: flex;
        justify-content: center;
        .under_banner_box {
          width: 90%;
          height: 100%;
          display: flex;
          justify-content: space-between;

          .under_banner_box_right {
            display: flex;
            align-items: center;

            .nav_list_works_left {
              // position: absolute;
              // right: 20%;
              // width: 60%;
              // width: 80%;
              margin-right: 10px;
              display: flex;
              align-items: center;
              select:focus {
                outline: none;
              }
              .single {
                border: 1px solid #3562ff;
                padding: 6px 18px;
                border-radius: 18px;
                cursor: pointer;
                font-size: 14px;
              }
              .select_box {
                position: relative;
                .select {
                  // width: 90px;
                  padding: 0 40px 0 45px;
                  border-color: #e3e3e3;
                  appearance: none;
                  -webkit-appearance: none; /*隐藏默认样式中的小三角*/
                  -moz-appearance: none;
                  color: #8f8f8f;
                  font-size: 14px;
                  height: 32px;
                  position: relative;
                  max-width: 185px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  cursor: pointer;
                  border-radius: 4px;
                }
              }

              .label {
                position: absolute;
                left: 10px;
                top: 50%;
                transform: translateY(-51%);
                font-size: 14px;
                color: #8f8f8f;
                z-index: 99;
              }
              .triangle {
                z-index: 99;
                position: absolute;
                right: 13px;
                top: 50%;
                transform: translateY(-50%);
                width: 7px;
                height: 5px;
                background-color: #8f8f8f;
                clip-path: polygon(0% 0%, 100% 0%, 50% 100%);
                transform-origin: center center;
              }
              .triangle_tr {
                transform: translateY(-50%) rotate(180deg) !important;
              }

              .nav_list_works_li {
                margin-right: 10px;
                // margin-bottom: 10px;
                height: 40px;
                // line-height: 40px;
                background: linear-gradient(301.69deg, #5377f7 13.72%, #3360ff 67.35%);
                color: #fff;
              }
              .nav_list_works_li_active {
                background: linear-gradient(301.69deg, #6688ff 13.72%, #3360ff 67.35%);
                color: #fff;
              }
              .nav_list_works_li_disactive {
                background: #f6f6f6;
                color: #8f8f8f;
              }

              .line {
                width: 1px;
                height: 28px;
                background-color: #c4c4c4;
                margin-left: 27px;
              }
            }

            .under_banner_left {
              // position: absolute;
              // left: 6%;
              color: #999;
              font-size: 16px;
              // line-height: 50px;
              // margin-right: 30px;
              text-align: center;
              width: 165px;
              div {
                display: inline-block;
                // margin-right: 15px;
                .under_banner_left_time {
                  display: inline-block;
                  height: 20px;
                  line-height: 20px;
                  background-color: rgba(241, 106, 88);
                  color: #ffffff;
                  margin: 0 5px;
                  padding: 0px 5px;
                }
              }
            }

            .under_banner_middle {
              // position: absolute;
              // left: 50%;
              // top: -5px;
              // transform: translate(-50%);
              // line-height: 50px;
              /deep/.van-popover__action {
                width: auto;
              }

              .tougao {
                // width: 150px;
                width: 180px;
                height: 44px;
                line-height: 44px;
                background: linear-gradient(301.69deg, #5377f7 13.72%, #3360ff 67.35%);
                color: #fff;
              }
              .tougao_state {
                background: linear-gradient(301.69deg, #999999 13.72%, #999999 67.35%);
                // background-color: #f6f6f6;
              }
              .van-button:nth-child(2) {
                width: 67px;
                height: 44px;
                line-height: 44px;
                margin-left: 30px;
                border: 1px solid #3562ff;
                color: #3562ff;
              }
            }
          }

          .under_banner_box_left {
            display: flex;
            align-items: center;

            .nav_list_head {
              text-align: center;
              height: 22px;
              line-height: 22px;
              color: black;
              // margin: 15px 0px 20px 0px;
              cursor: pointer;

              span {
                padding: 6px 18px;
                // padding: 6px 18px 6px 18px;
                border-radius: 16px;
              }
              .nav_list_head_item {
                color: #c4c4c4;
                margin: 0px 15px;
                font-size: 12px;
              }
              .active {
                color: #3562ff;
                border: 1px solid #3265ff;
                font-size: 17px;
                font-weight: 600;
              }
            }

            .under_banner_bottom {
              // text-align: center;
              // position: absolute;
              // bottom: 0px;
              // left: 50%;
              // transform: translate(-50%);
              margin-right: 1px;

              span {
                display: inline-block;
                // width: 80px;
                line-height: 30px;
                box-sizing: border-box;
                margin-right: 20px;
                cursor: pointer;
              }
              span:hover {
                color: #3265ff;
              }
              .heat {
                position: absolute;
                margin-left: 180px;
                color: #8f8f8f;
                right: -290px;
                top: 0;
                .text {
                  margin-right: 7px;
                  display: inline-block;
                }
                .icon {
                  display: inline-block;
                  .top {
                    width: 7px;
                    height: 5px;
                    background-color: #8f8f8f;
                    clip-path: polygon(50% 0, 0 100%, 100% 100%);
                    margin-bottom: 2px;
                  }
                  .bottom {
                    width: 7px;
                    height: 5px;
                    background-color: #8f8f8f;
                    clip-path: polygon(0 0, 100% 0, 50% 100%);
                  }
                }
              }
            }
          }
        }
      }

      .listData {
        display: flex;
        justify-content: center;
      }

      .division_table {
        padding: 15px 10px 0;
        display: flex;
        justify-content: center;
        .organization_box {
          width: 420px;
          background-color: #fff6f0;
          // border-top-left-radius: 14px;
          // border-top-right-radius: 14px;
          padding: 0 9px 10px;
          border-radius: 14px;
          position: relative;
          .position_right {
            position: absolute;
            right: 0;
            top: 0;
          }

          .head_img_box {
            margin: 0 auto;
            width: 315px;
            height: 40px;
            padding-top: 5px;
            // transform: translateY(8px);
            display: flex;
            align-items: center;
            justify-content: center;
            color: #f77224;
            font-size: 16px;
            font-weight: 700;
            img {
              // transform: scale(1.2);
              object-fit: contain;
              width: 20px;
              height: 20px;
              margin-right: 7px;
              // width: 100%;
              // height: 100%;
            }
          }

          .organization_content {
            // background-color: #fff;
            // border-top-left-radius: 14px;
            // border-top-right-radius: 14px;
            padding: 0 5px;
            border-radius: 14px;
            position: relative;
            // padding-bottom: 20px;
            z-index: 10;

            .organization_content_head {
              height: 36px;
              display: flex;
              align-items: center;
              font-size: 14px;
              color: #8a8f93;

              .organization_name {
                width: 220px;
                text-align: center;
              }
              .number_works {
                width: 90px;
                padding-left: 5px;
              }
            }

            .organization_content_item {
              cursor: pointer;
              height: 36px;
              border: 1px solid #f4e5db;
              background-color: rgba(255, 225, 206, 0.5);
              border-radius: 14px;
              display: flex;
              align-items: center;
              font-size: 12px;
              color: #1a1a1a;
              margin-bottom: 12px;

              .list_icon {
                width: 15px;
                height: 17px;
                margin: 0 10px;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .icon_txt {
                font-size: 16px;
                font-family: YouSheBiaoTiHei;
                color: #999;
                text-align: center;
              }
              .organization_name {
                width: 220px;
                display: flex;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;

                .organization_logo {
                  width: 19px;
                  height: 19px;
                  margin-right: 5px;
                  img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                  }
                }
              }
              .number_works {
                width: 90px;
                padding-left: 10px;
              }

              .number_img {
                display: flex;
                flex: 1;
                justify-content: space-between;
                padding-right: 20px;
                align-items: center;

                .organization_content_item_state {
                  .rise {
                    display: flex;
                    align-items: center;
                    color: #f23e3e;
                    .rise_icon {
                      width: 7px;
                      height: 4px;
                      margin-right: 2px;
                      background-color: #f23e3e;
                      clip-path: polygon(50% 0, 100% 100%, 0% 100%);
                    }
                  }

                  .decline {
                    display: flex;
                    align-items: center;
                    color: #51dd20;
                    .decline_icon {
                      width: 7px;
                      height: 4px;
                      margin-right: 2px;
                      background-color: #51dd20;
                      clip-path: polygon(0 0, 100% 0, 50% 100%);
                    }
                  }

                  .new_ste {
                    width: 16px;
                    height: 16px;
                    font-size: 10px;
                    background-color: #f9cdcd;
                    color: #f23e3e;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  }
                }
              }
            }
          }
        }
      }

      .organization {
        padding: 15px 10px 0;
        display: flex;
        justify-content: center;
        position: relative;
        height: 100%;

        .organization_box {
          width: 420px;
          background-color: #f0f6ff;
          // border-top-left-radius: 14px;
          // border-top-right-radius: 14px;
          padding: 0 9px 10px;
          border-radius: 14px;
          position: relative;
          .position_right {
            position: absolute;
            right: 0;
            top: 0;
          }

          .head_img_box {
            margin: 0 auto;
            width: 315px;
            height: 40px;
            padding-top: 5px;
            // transform: translateY(8px);
            display: flex;
            align-items: center;
            justify-content: center;
            color: #1472ff;
            font-size: 16px;
            font-weight: 700;
            img {
              width: 20px;
              height: 20px;
              margin-right: 7px;
              object-fit: contain;
              // width: 100%;
              // height: 100%;
            }
          }

          .organization_content {
            // background-color: #fff;
            // border-top-left-radius: 14px;
            // border-top-right-radius: 14px;
            padding: 0 5px;
            border-radius: 14px;
            position: relative;
            // padding-bottom: 20px;
            z-index: 10;

            .organization_content_head {
              height: 36px;
              display: flex;
              align-items: center;
              font-size: 14px;
              color: #8a8f93;

              .organization_name {
                width: 220px;
                text-align: center;
              }
              .number_works {
                width: 90px;
                padding-left: 5px;
              }
            }

            .organization_content_item {
              cursor: pointer;
              height: 36px;
              border: 1px solid #d1def2;
              background-color: rgba(209, 222, 242, 0.32);
              border-radius: 14px;
              display: flex;
              align-items: center;
              font-size: 12px;
              color: #1a1a1a;
              margin-bottom: 12px;

              .list_icon {
                width: 15px;
                height: 17px;
                margin: 0 10px;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .icon_txt {
                font-size: 16px;
                font-family: YouSheBiaoTiHei;
                color: #999;
                text-align: center;
              }
              .organization_name {
                width: 220px;
                display: flex;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;

                .organization_logo {
                  width: 19px;
                  height: 19px;
                  margin-right: 5px;
                  img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                  }
                }
              }
              .number_works {
                width: 90px;
                padding-left: 10px;
              }

              .number_img {
                display: flex;
                flex: 1;
                justify-content: space-between;
                padding-right: 20px;
                align-items: center;

                .organization_content_item_state {
                  .rise {
                    display: flex;
                    align-items: center;
                    color: #f23e3e;
                    .rise_icon {
                      width: 7px;
                      height: 4px;
                      margin-right: 2px;
                      background-color: #f23e3e;
                      clip-path: polygon(50% 0, 100% 100%, 0% 100%);
                    }
                  }

                  .decline {
                    display: flex;
                    align-items: center;
                    color: #51dd20;
                    .decline_icon {
                      width: 7px;
                      height: 4px;
                      margin-right: 2px;
                      background-color: #51dd20;
                      clip-path: polygon(0 0, 100% 0, 50% 100%);
                    }
                  }

                  .new_ste {
                    width: 16px;
                    height: 16px;
                    font-size: 10px;
                    background-color: #f9cdcd;
                    color: #f23e3e;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .pc_index_head {
    width: 80%;
    margin: 0px auto;

    display: flex;
    justify-content: space-between;
    height: 64px;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    align-items: center;
  }
  .pc_index_main {
    width: 90%;
    margin: 0px auto;

    .sticky_second {
      position: sticky;
      top: 44px;
      padding-top: 10px;
      z-index: 99;
      background-color: #fff;
      padding-bottom: 10px;
      box-sizing: border-box;
    }
    .heat {
      position: absolute;
      margin-left: 180px;
      color: #8f8f8f;
      .text {
        margin-right: 7px;
        display: inline-block;
      }
      .icon {
        display: inline-block;
        .top {
          width: 7px;
          height: 5px;
          background-color: #8f8f8f;
          clip-path: polygon(50% 0, 0 100%, 100% 100%);
          margin-bottom: 2px;
        }
        .bottom {
          width: 7px;
          height: 5px;
          background-color: #8f8f8f;
          clip-path: polygon(0 0, 100% 0, 50% 100%);
        }
      }
    }
    .nav_list_works {
      // text-align: center;
      position: relative;

      .new_seach {
        position: absolute;
        right: 10px;
        top: -10px;
        width: 15%;
        height: 40px;
        line-height: 40px;
        text-align: center;
      }
    }
    .saiqu {
      width: 100%;
      box-sizing: border-box;
      // padding: 0 0.4267rem;
      overflow-y: auto;
      // white-space: nowrap;
      // text-align: center;

      .saiqu_li {
        height: 30px;
        box-sizing: border-box;
        padding: 0 0.2133rem;
        border-radius: 0.32rem;
        color: #8f8f8f;
        font-size: 16px;
        font-weight: 400;
        line-height: 30px;
        // margin-right: 0.1rem;
        display: inline-block;
        // background: #f6f6f6;
        margin-bottom: 10px;
        cursor: pointer;
      }
      .saiqu_li:hover {
        color: #3360ff;
      }
      .option {
        display: inline-block;
      }

      .active {
        background: linear-gradient(301.69deg, #6688ff 13.72%, #3360ff 67.35%);
        color: #fff;
      }
    }

    .saiqu::-webkit-scrollbar {
      display: none;
    }

    .saiqu {
      overflow: -moz-scrollbars-none;
    }
    .data_list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .van-list {
        width: 100%;
        box-sizing: border-box;
        overflow: hidden;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        // justify-content: space-between;
        align-items: flex-start;
        box-sizing: border-box;
        // padding: 0.5333rem 0.4267rem;
        // padding: 0.5333rem 0.6267rem;
        padding: 0.1333rem 0.2rem 0.5333rem 0.2rem;
        // margin: 0.5333rem 0 2.1333rem 0;
        margin: 0 0 2.1333rem 0;

        /deep/.van-list__loading {
          width: 100%;
          text-align: center;
        }

        /deep/ .van-list__placeholder {
          width: 100%;
          text-align: center;
        }
      }

      &::after {
        content: '';
        flex-grow: 99999;
      }
      .flex_grow {
        flex-grow: 0 !important;
      }
      .data_list_li {
        flex-grow: 1;
        margin-right: 10px;
        // height: 350px;
        margin-bottom: 10px;
        position: relative;
        background-color: #fff;
        cursor: pointer;
        .mask {
          position: absolute;
          width: 100%;
          top: 0;
          left: 0;
          background: rgba(0, 0, 0, 0.5);
        }
        .img {
          // object-fit: cover;
          background-size: cover;
          background-position: center;

          img {
            opacity: 1;
            min-width: 100%;
            // height: 350px;
            height: 210px;
            animation: img 1s ease-in-out;
          }
        }
        @keyframes img {
          0% {
            opacity: 0;
          }

          100% {
            opacity: 1;
          }
        }
        .abpos {
          position: absolute;
          right: 5px;
          top: 5px;
          width: 32px;
          display: flex;
          z-index: 3;
          align-items: center;
          justify-content: center;
          height: 20px;
          background: rgba(177, 177, 177, 0.3);
          border-radius: 4px;

          i {
            color: #fff;
            font-size: 12px;
          }

          span {
            color: #fff;
            font-size: 10px;
            font-weight: 500;
          }
        }

        // img {
        //   height: 350px;
        // }

        video {
          width: 4.2133rem;
          height: auto;
          display: block;
          border-radius: 0.1067rem 0.1067rem 0 0;
        }
        // video{
        //      opacity: 1;
        //     min-width: 100%;
        //     height: 350px;
        // }

        .data_list_avater {
          position: absolute;
          left: 10px;
          bottom: 15px;
          height: 40px;

          img {
            display: inline-block;
            height: 40px;
            width: 40px;
            border-radius: 50%;
            margin-right: 10px;
          }
          span {
            position: relative;
            top: -13px;
            height: 40px;
            line-height: 40px;
            color: #fff;
          }
        }
        .data_list_li_p {
          font-size: 0.2667rem;
          font-weight: 300;
          height: 30px;
          position: absolute;
          right: 10px;
          bottom: 35px;

          p {
            margin-right: 10px;
            color: #1a1a1a;
            text-align: center;
            width: 40px;
            height: 30px;
            line-height: 30px;
            display: inline-block;
            background-color: #fff;
            border-radius: 5px;
          }

          i {
            color: #8f8f8f;
            font-size: 0.25rem;
            // margin-right: 0.08rem;
          }
        }

        // span {
        //   color: #3562ff;
        //   font-size: 0.2933rem;
        //   font-weight: 400;
        // }
      }
      // .data_list_li:nth-child(3n + 0) {
      //   margin-right: 0px;
      // }
    }
  }
  .fiex {
    width: 4.5867rem;
    border-radius: 0.1067rem;
    background-color: rgba(0, 0, 0, 0.6);
    position: fixed;
    z-index: 9999;
    bottom: 2.1333rem;
    right: 1.0667rem;
    box-sizing: border-box;
    padding: 0.2667rem 0;

    .fiex_item {
      width: 3.6267rem;
      height: 0.96rem;
      border-radius: 0.4267rem;
      background-color: #fff;
      display: flex;
      flex-direction: row;
      align-items: center;
      box-sizing: border-box;
      padding: 0.08rem;
      margin: 0.2133rem auto;

      img {
        width: 0.8rem;
        height: 0.8rem;
        border-radius: 50%;
        display: block;
        margin-right: 0.16rem;
      }

      span {
        color: #1a1a1a;
        font-size: 0.3733rem;
        font-weight: 400;
      }
    }
  }

  .fiex::after {
    content: '';
    width: 0;
    height: 0;
    border-left: 0.16rem solid transparent;
    border-right: 0.16rem solid transparent;
    border-top: 0.2667rem solid rgba(0, 0, 0, 0.6);
    position: absolute;
    left: 0.4rem;
    bottom: -0.2667rem;
  }
}
</style>
